<script>
  /**
   * @type {string} - The color of the logo
   * @default '#FF5F1F'
   */
  export let color = '#FF5F1F'
</script>

<svg width="29" height="22" viewBox="0 0 29 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M24.0203 21.2843H29L21.062 10.1022L28.4782 0H23.6755L18.3986 7.63169L13.2534 0H8.31682L15.6082 10.2769L15.5606 10.3404L7.71564 21.2843H12.5637L18.3578 12.9199L24.0203 21.2843Z"
    fill={color}
  />
  <path d="M12.473 10.2815L5.53774 0H0.603458L7.89259 10.2769L7.84721 10.3404L0 21.2843H4.85035L8.16256 16.4998L12.473 10.2815Z" fill={color} />
</svg>
